/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ConsoleLoggerService } from './logger-console.service';
export abstract class Logger {
  info: any;
  warn: any;
  error: any;
}

@Injectable({
  providedIn: 'root',
  useClass: ConsoleLoggerService
})
export class LoggerService implements Logger {
  info: any;
  warn: any;
  error: any;
}
